<ng-container *ngIf="news$ | async as items">
  <div
    *ngIf="items.length > 0"
    [ngClass]="listCategory && currPage !== 'NewsPageTemplate' ? 'related-news-wrapper' : 'news-home-wrapper'"
  >
    <div class="container">
      <div [ngClass]="currPage == 'NewsPageTemplate' ? 'd-none' : 'sectionHeader'">
        <div *ngIf="relatedNews; else newsTitle" class="sectionName">
          {{ 'newsArticles.relatedSection' | cxTranslate }}
        </div>

        <div *ngIf="!listCategory" class="viewAll">
          <a tabindex="0" [routerLink]="'/news'">
            {{ 'newsArticles.viewAllLink' | cxTranslate }} <i class="material-icons">keyboard_arrow_right</i>
          </a>
        </div>
      </div>

      <ngx-slick-carousel
        *ngIf="currPage != 'NewsPageTemplate'"
        class="carousel"
        #slickModal="slick-carousel"
        [config]="slickConfig"
        (init)="slickInit($event)"
      >
        <div ngxSlickItem *ngFor="let data of items" class="slide">
          <div class="item">
            <a tabindex="0" [routerLink]="data.link">
              <span class="news-image" *ngIf="data.thumbnail; else defaultImage">
                <cx-media class="card-img-top" [container]="data.thumbnail" removeImageTitleAttr> </cx-media>
              </span>
              <ng-template #defaultImage>
                <span class="news-image">
                  <cx-media class="card-img-top" [container]="data.image" removeImageTitleAttr> </cx-media>
                </span>
              </ng-template>
              <span class="news-label">{{ data.categoryName }}</span>
              <span class="news-title">{{ data.title }}</span>
              <span class="news-desc">
                <p>{{ data.shortOverview }}</p>
              </span>
            </a>
          </div>
        </div>
      </ngx-slick-carousel>

      <div *ngIf="currPage == 'NewsPageTemplate'" class="news-result-wrapper">
        <div class="news-card-wrapper">
          <div class="news-card" *ngFor="let news of items">
            <a tabindex="0" [routerLink]="news.link">
              <span class="news-image" *ngIf="news.thumbnail; else defaultImage">
                <cx-media class="card-img-top" [container]="news.thumbnail" removeImageTitleAttr> </cx-media>
              </span>
              <ng-template #defaultImage>
                <span class="news-image">
                  <cx-media class="card-img-top" [container]="news.image" removeImageTitleAttr> </cx-media>
                </span>
              </ng-template>
              <div class="news-label">{{ news.categoryName }}</div>
              <div class="news-title">{{ news.title }}</div>
              <div class="news-desc">
                <p>{{ news.shortOverview }}</p>
              </div>
            </a>
          </div>
        </div>
      </div>

      <div *ngIf="currPage == 'NewsPageTemplate'" class="pagination-wrapper">
        <app-pagination
          (viewPageEvent)="pageChange($event)"
          [pagination]="PaginationModel"
          [hideOnSinglePage]="true"
        ></app-pagination>
      </div>
    </div>
  </div>
</ng-container>
<ng-template #newsTitle>
  <div class="sectionName">{{ 'newsArticles.newsTitle' | cxTranslate }}</div>
</ng-template>
